import { api } from 'utility';
import { getWithdrawRulePlanUrl, getWithdrawRuleLinkUrl } from 'URLs';

export function getWithdrawRules(params) {
  return api.get(getWithdrawRulePlanUrl(), { params }).then((res) => res.data);
}

export function getRuleLink(planId) {
  return api.get(getWithdrawRuleLinkUrl(planId)).then((res) => res.data);
}

export default {
  getWithdrawRules,
  getRuleLink,
};
